module.exports = __webpack_public_path__ + "img/resume_thumbnail-1-400x300.64a12e54.jpg";